export default __webpack_public_path__ + "static/media/custom-banner.c76ec057.jpg";